import {
  ProgramTemplateDto,
  LibraryPrivacy,
} from "@growth-machine-llc/stridist-api-client";
import React from "react";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import {
  LibraryPrivacyBadge,
  privacyTooltip,
} from "../badge/LibraryPrivacyBadge";

interface IProgramTemplatePrivacyBadgeProps {
  template: ProgramTemplateDto;
  size?: number;
  showLabel?: boolean;
}

export function ProgramTemplateTypeBadge({
  template,
  size = 40,
  showLabel = true,
}: IProgramTemplatePrivacyBadgeProps) {
  const user = useCurrentUser();

  const owner = template.author ?? user;

  const tooltip = privacyTooltip(
    "program template",
    template.privacy,
    template.privacy === LibraryPrivacy.TEAM ? owner?.displayName : undefined,
  );

  return (
    <LibraryPrivacyBadge
      privacy={template.privacy}
      owner={
        owner
          ? {
              photoUrl: owner.photoUrl,
              displayName: owner.displayName,
            }
          : undefined
      }
      tooltip={tooltip}
      size={size}
      showLabel={false}
    />
  );
}
